import axios from "axios";
import api from "../api";
import product_service from "./product-service";
import provider_service from "./provider-service";
import store from "@/store";

function create(params, inverter) {
  return new Promise(async (resolve, reject) => {
    if (!inverter) {
      product_service.create(params).then(async (product) => {
        store.dispatch("alerts/success", "Inversor criado com sucesso");
        store.dispatch("inverter/setCreatedProduct", product);
        await createInverterConfigs({ id: product.id, config: params.config });
        await provider_service.updateProductSupplier({
          product_id: product.id,
          params: params.suppliers,
        });
        await createInverterAttachments(product.id, params.attachments)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
        await product_service.createProductDimensions(product.id,params.dimensions);
      });
    } else {
      await createInverterConfigs({ id: inverter.id, config: params.config });
      await provider_service.updateProductSupplier({
        product_id: product.id,
        params: params.suppliers,
      });
      await createInverterAttachments(inverter.id, params.attachments)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
        await product_service.createProductDimensions(product.id,params.dimensions);
    }
  });
}

function createInverterConfigs(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.products}/${params.id}/inverter_configs`, {
        inverter_id: params.id,
        ...params.config,
      })
      .then((response) => {
        store.dispatch(
          "alerts/success",
          "Configurações de Inversor criadas com sucesso"
        );
        resolve(response);
      })
      .catch((error) => {
          reject(error);
      });
  });
}

function createInverterAttachments(product_id, attachments) {
  return new Promise((resolve, reject) => {
    axios
      .post(`${api.products}/${product_id}/attachments`, attachments)
      .then((response) => {
        store.dispatch(
          "alerts/success",
          "Anexos de Inversor criados com sucesso"
        );
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function read(params = {}, id) {
  return {
    inverters: await product_service.getProductByCategoryId({
      ...params,
      url_filter: true,
      url_params: { category: id, ...params.url_params },
    }),
  };
}

async function update(params) {
  return new Promise((resolve, reject) => {
    axios
      .put(api.products + "/" + params.id, params.product)
      .then(async (response) => {
        store.dispatch("alerts/success", "Inversor editado com sucesso");
        await updateInverterConfigs(params);
        await updateInverterAttachments(params.id, params.attachments);
        await provider_service
          .updateProductSupplier({
            product_id: params.id,
            params: params.suppliers,
          })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
        await product_service.updateProductDimensions(params.id,params.dimensions);
      });
  });
}

async function updateInverterConfigs(params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.products}/${params.id}/inverter_configs`, params.config)
      .then((response) => {
        store.dispatch(
          "alerts/success",
          "Configurações de inversor editadas com sucesso"
        );

        resolve({
          inverter_configs: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function updateInverterAttachments(product_id, attachments) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${api.products}/${product_id}/attachments`, attachments)
      .then((response) => {
        store.dispatch(
          "alerts/success",
          "Anexos de inversor editados com sucesso"
        );
        resolve({
          inverter_attachments: response.data,
        });
      })
      .catch((error) => {
        store.dispatch("alerts/success", "Error ao editar anexos de inversor");
        reject(error);
      });
  });
}

async function destroy(id) {
  return new Promise(async (resolve, reject) => {
    await destroyInverterConfigs(id);
    axios
      .delete(`${api.products}/${id}`)
      .then((response) => {
        resolve({
          inverter: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function destroyInverterConfigs(id) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`${api.products}/${id}/inverter_configs`)
      .then((response) => {
        resolve();
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getConfigsById(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.products}/${id}/inverter_configs`)
      .then((response) => {
        resolve({
          inverter_configs: response.data,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

async function getAttachmentsById(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${api.products}/${id}/attachments`)
      .then((response) => {
        resolve({
          inverter_attachments: response.data.attachments,
        });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export default {
  read,
  create,
  update,
  destroy,
  getConfigsById,
  getAttachmentsById,
};
